export const relation = {
  self: "ตัวเอง",
  child: "บุตร",
  spouse: "คู่สมรส",
  mom: "แม่",
  dad: "พ่อ",
}
